import React, { Component } from 'react';
import RothButton from '../components/RothButton.js';

export default class DisclaimerPage extends Component {
  style = {};
  render = () => (
    <div className="content">
      <RothButton type="back" fn={this.props.changePage} param={this.props.backPage} value={this.props.backSubPage}>
        {'← ' + this.props.text('other', 'back')}
      </RothButton>
      <div className="inner">
        <div style={{ padding: '0px 40px' }}>
          <h1 style={{ marginLeft: '0px' }}>{this.props.text('disclaimer', 'h1')}</h1>
          <div dangerouslySetInnerHTML={{ __html: this.props.text('disclaimer', 'text') }} />
        </div>
        <div />
      </div>
      <RothButton disabled={!this.props.isPageAllowed('disclaimer')} type="wide" fn={this.props.acceptDisclaimer} value="summary">
        {this.props.text('disclaimer', 'accept')}
      </RothButton>
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/views/DisclaimerPage.js
 **/